/**
 * Product branding, in one place. Change it here and every screen follows.
 *
 * <p>The theme, the shell primitives and the appearance menu are HospitalERP's, reused wholesale so
 * anyone moving between the two products recognises the second immediately. What differs is the
 * name, so it lives here rather than being spelled out across a dozen components — and the field
 * names match HospitalERP's so the copied components need no edits.</p>
 *
 * <p>NOTE — do not confuse this with the <i>integration</i> named HealNTrack (the hospital
 * information system this app projects master data from: <code>integration.healntrack</code>,
 * <code>IMasterDataOwnership</code>, the handoff pack). Those identifiers name the partner system
 * and keep their spelling regardless of what the product is called.</p>
 */
export const BRAND = {
  /** Full product name — page titles, login, install prompts. */
  name: "HealNTrack HMS",
  /** Anywhere space is too tight for the full name. */
  shortName: "HMS",
} as const;

/** "HealNTrack HMS" — the browser tab / document title. */
export const documentTitle = BRAND.name;
